module.exports = "\n\t<div class=\"col-12 text-center box-danger \" style=\"width:87vw;top:45%;margin: auto;\">\n\t <h2> ERROR 404 : PÁGINA NO ENCONTRADA </h2>\n\t <p> Parece que esta página no existe, por favor verifique su URL o simplemente <span class=\"f-bold darkblue cursor-pointer f-underline-h\"\n\t \t(click)=\"onBack();\"> REGRESE </span> a donde estabas.  \n\t</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/error/error.component.html
// module id = ../../../../../src/app/shared/error/error.component.html
// module chunks = main